import { TransactionState } from '@/types'

export const transactionFailedStates = [
  TransactionState.Failed,
  TransactionState.Cancelled
]

export const transactionCompleteStates = [
  ...transactionFailedStates,
  TransactionState.Completed
]
